export const ApiErrorMsg = {
  AbortedDueNextRequest: 'AbortedDueNextRequest',
};
